import React from 'react'
import styled from 'styled-components'

const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding: ${props => props.pad};
`

const IconButton = ({ onClick, icon, pad, ...rest }) => {
  return (
    <Button {...rest} onClick={onClick} pad={pad}>
      {icon}
    </Button>
  )
}

export default IconButton
